<template>
    <div class="card-metrica">
        <div class="card-metrica-header">
            <h4>{{ titulo }}</h4>
            <i v-if="icone" :class="icone" class="card-metrica-icone"></i>
        </div>
        <div class="card-metrica-valor">
            {{ valorFormatado }}
        </div>
        <div v-if="subtitulo" class="card-metrica-subtitulo">
            {{ subtitulo }}
        </div>
    </div>
</template>

<script>
export default {
    name: 'CardMetrica',
    props: {
        titulo: {
            type: String,
            required: true
        },
        valor: {
            type: [Number, String],
            required: true
        },
        subtitulo: {
            type: String,
            default: ''
        },
        icone: {
            type: String,
            default: ''
        },
        tipo: {
            type: String,
            default: 'numero', // 'numero', 'moeda', 'percentual'
            validator: (value) => ['numero', 'moeda', 'percentual'].includes(value)
        }
    },
    computed: {
        valorFormatado() {
            if (this.tipo === 'moeda') {
                const num = typeof this.valor === 'string' ? parseFloat(this.valor.replace(/[^\d,-]/g, '').replace(',', '.')) : this.valor;
                return new Intl.NumberFormat('pt-BR', {
                    style: 'currency',
                    currency: 'BRL'
                }).format(num || 0);
            } else if (this.tipo === 'percentual') {
                const num = typeof this.valor === 'string' ? parseFloat(this.valor) : this.valor;
                return `${(num || 0).toFixed(1)}%`;
            } else {
                const num = typeof this.valor === 'string' ? parseFloat(this.valor) : this.valor;
                return new Intl.NumberFormat('pt-BR').format(num || 0);
            }
        }
    }
};
</script>

<style scoped>
.card-metrica {
    background: var(--cor-bg, white);
    border: 1px solid var(--cor-separador, #ddd);
    border-radius: 8px;
    padding: 1.5rem;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    transition: box-shadow 0.2s ease, transform 0.2s ease;
}

.card-metrica:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    transform: translateY(-2px);
}

.card-metrica-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.card-metrica-header h4 {
    margin: 0;
    font-size: 0.9rem;
    font-weight: 600;
    color: var(--cor-fonte-secundaria, #666);
}

.card-metrica-icone {
    font-size: 1.5rem;
    color: var(--cor-primaria, #3697d3);
}

.card-metrica-valor {
    font-size: 2rem;
    font-weight: 700;
    color: var(--cor-fonte, #333);
    line-height: 1.2;
}

.card-metrica-subtitulo {
    font-size: 0.85rem;
    color: var(--cor-fonte-secundaria, #999);
    margin-top: 0.25rem;
}
</style>

